import { Guide } from '../../lib/types/models/guide/guide'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getGuide(id: number) {
  return restApiClient.url(constructApiUrl(API.guides.get.url, { id })).get<Guide>()
}
